import { hasValue } from './validation';

export function displayNocValuesForGridTemplate(e: any): string {
  if (!hasValue(e.natureOfCallValues)) {
    return '';
  }
  return e.natureOfCallValues.join(', ');
}
